import {
  FieldValues,
  useForm,
  UseFormProps,
  UseFormReturn,
} from "react-hook-form";

export function useFormCompat<
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
  TTransformedValues = TFieldValues,
>(
  props?: UseFormProps<TFieldValues, TContext, TTransformedValues>
): UseFormReturn<TFieldValues, TContext, TTransformedValues> {
  // Disable React Compiler until React Hook Form supports it.
  // https://github.com/orgs/react-hook-form/discussions/12524
  "use no memo";

  return useForm(props);
}
